import { useNavigate } from 'react-router-dom';

import { Payment } from '../../../../models/common-payments';
import { fillStatesWithZeros } from '../../../../utils/states';
import { PLRoutes } from '../../enums/routes.enum';
import { CustomPLTable } from '../custom-pl-table';
import { PaymentLinkTableProps } from './types';

const PaymentLinkTable = ({
	allowedCustomAction = false,
	allowExport = false,
	handleExportAction,
	columns,
	data,
	filters,
	hasFilters = false,
	hasDateFilters = true,
	hasSearch = false,
	isLoading,
	onFilterChange,
	pagination,
	setPagination,
	stateList,
	titleTable,
	totalResults,
}: PaymentLinkTableProps) => {
	const navigate = useNavigate();

	const handleRedirectAllPayments = () => {
		navigate(PLRoutes.ALL);
	};

	const handleDisabledRow = (data: Payment) => {
		const { status } = data;
		return status != 'success' && status != 'pending';
	};

	return (
		<CustomPLTable<Payment>
			title={titleTable}
			data={data}
			disabledRow={handleDisabledRow}
			isLoading={!!isLoading}
			columns={columns}
			hasFilters={hasFilters}
			hasDateFilter={hasDateFilters}
			allowCustomaAction={allowedCustomAction}
			customActionText="Ver Todos"
			customAction={() => handleRedirectAllPayments()}
			allowExport={allowExport}
			stateList={fillStatesWithZeros({ stateList })}
			filters={filters}
			onFilterChange={onFilterChange}
			hasSearch={hasSearch}
			exportAction={handleExportAction}
			hasPagination={!!totalResults && totalResults > 0}
			totalResults={totalResults}
			pagination={pagination}
			setPagination={setPagination}
		/>
	);
};

export { PaymentLinkTable };
